import { ItemSummary } from '../admin/items/items.models';
import { ItemWithMetadata } from '../models/item';
import { ItemDetailsForTree } from '../root-store/object-tree-store/object-tree.models';

export const iconMapping: { [key: string]: string } = {
  Building: 'home',
  Room: 'meeting_room',
  Accessory: 'home_repair_service',
  OutdoorFacility: 'beach_access',
  Folder: 'folder',
  Service: 'engineering',
  GiftCard: 'card_giftcard',
  Other: 'miscellaneous_services'
}

export function getIconName(itemOrItemType: ItemWithMetadata | ItemSummary | ItemDetailsForTree | string): string {
  let itemType: string

  if (typeof itemOrItemType === 'string')
    itemType = itemOrItemType
  else if ('itemType' in itemOrItemType)
    itemType = itemOrItemType.itemType
  else
    itemType = itemOrItemType.type

  return iconMapping[itemType]
}
